import { render, staticRenderFns } from "./keyWordImport.vue?vue&type=template&id=195288f0"
import script from "./keyWordImport.vue?vue&type=script&lang=js"
export * from "./keyWordImport.vue?vue&type=script&lang=js"
import style0 from "./keyWordImport.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports